import Reviews from "components/homepage/reviews";
import ServicesGrid from "components/homepage/servicesGrid";
import TranslationServices from "components/homepage/translationServices";
import WhatChooseUs from "components/homepage/whyChooseUs";
import LocationBanner from "components/locationBanner";
import Popular from "components/LocationReusableComp/popular";
import TrustedTranslation from "components/LocationReusableComp/trustedtranslation";
import React from "react";
import AcadmicInstruction from "../AcadmicInstruction";
import Assuredservice from "../assuredservice";
import CertificationSamples from "../certificationSamples";
import Certify from "../certify";
import LocalizationMidText from "../localizationMidText";
import TechnicalDocument from "../technicalDocument";
import WhatsAppComp from "../whatsappComp";
import CertifiedProvide from "../certifiedProvide";
import { CertData, Languages } from "./config";
import { Link } from "gatsby";
import TranslateAgency from "components/homepage/translateAgency";

export default function CertifiedTranslation() {
  return (
    <div>
      <LocationBanner
        title="Certified Translation Services - 100% Guaranteed"
        backgroundCol="bg-midBlue"
        content="Tomedes is authorized to certify that a translated document exactly and faithfully represents the content of the original. Certified translation services are required by authorities and professional bodies in many jurisdictions. We guarantee that our translation certificates will be accepted universally. Tomedes translates in over 120 languages and 950+ language pairs, with rapid delivery, a 1-year guarantee, and 24/7 customer support."
        formOrangeHead="Get in touch "
        formWhiteHead=" with our certified translation agency"
      />
      {/* <AcadmicInstruction
        head="Certified translation services"
        content="Broaden your horizons with our certified translation solutions. Our certified translation services are guaranteed to solve all your submission problems by providing global solutions for your various requirements. We provide certified translations that are authentic representations of your original documents."
        colorHead="guaranteed"
        secondHead=""
        thirdColorHead="text-LightBlue"
        thirdHead="by companies and individuals worldwide"
      /> */}
      <TranslateAgency
        head="Certified translation services"
        colorHead="guaranteed"
        lastHeadText="by companies and individuals worldwide"
        content="Broaden your horizons with our certified translation solutions. Our certified translation services are guaranteed to solve all your submission problems by providing global solutions for your various requirements. We provide certified translations that are authentic representations of your original documents."
      />

      <LocalizationMidText
        fText="Our"
        orangeMidText="certified"
        content="translation services are guaranteed to solve all
your submission problems by providing global solutions for your
various requirements. We provide certified translations that are
authentic representations of your original documents."
      />
      <Assuredservice backgroundCol="" />
      <Certify backgroundCol="bg-midBlue" />
      <WhatsAppComp
        backgroundCol="bg-darkBlue"
        fHead="Looking"
        secondHead="for Certified Translators?"
        content="Tomedes has a worldwide team of translators accredited to certify translations of practically any type of document for virtually every jurisdiction. We offer a 100% 1-year guarantee on our certified translation services."
        whatsUp
      />
      <ServicesGrid
        heading="Certified Translation Services For Every Industry Imaginable"
        details="Certification is often required by government agencies, insurance companies, courts, and other professional bodies as proof that the translation is a true and exact representation of the original in another language."
        contactUs={
          <Link
            to="/contactus.php"
            className="bg-orange text-white rounded-3xl uppercase py-2 px-8 mt-6 inline-block  mlap:mb-10"
          >
            contact us
          </Link>
        }
      />
      <TrustedTranslation
        FirstWhite="Our"
        headColor="text-lightBlue"
        ColorHead="Network"
        SecondWhite="of Certified Translators"
        Content="Tomedes commands a worldwide network of thousands of translators, giving us the ability to provide certified translation services in virtually any language, and in any country, on-demand. Beware of impostors: not every translator is accredited to provide certified language translation services. We make it our business to hire and train the most talented translators in the world. Our senior linguists have the training and accreditation to certify a translation as a true and accurate representation of an original document verified for use in a given legal jurisdiction. Our account managers ensure that from the start of every project you are matched with the professional team most suited to successfully complete your certified translation."
      />
      <CertifiedProvide
        data={CertData}
        FirstHead="The"
        ColorHead="Certified "
        secondHead="Translation Services
We Provide"
      />

      <TechnicalDocument
        secondHead="us your documents"
        para="To get started with your certified translation, just send us the original to be translated and the languages and
jurisdictions requiring certification."
      />
      <CertificationSamples backgroundCol="bg-midBlue" />
      <Popular
        bottomBorderText
        languageCount="Certified Translation Services In Any Language"
        details="Our global staff also includes domain experts and specialists in virtually every industry and field of endeavor to ensure that the certified translation services are as accurate and professional as possible."
        bottomHeading="Commonly Requested Languages for Certification"
        location=" "
        data={Languages}
        footerTitle="Didn't see the language you needed?"
        footerDetails="Tomedes commands a global network comprising thousands of expert linguists skilled in translating more than 120 languages and 950+ language pairs."
        btnName="SEE OUR SUPPORTED LANGUAGES"
        backgroundCol="bg-darkBlue"
      />
      <WhatChooseUs />
      <Reviews backgroundCol="bg-darkBlue" />
      <TranslationServices backgroundCol="bg-midBlue" />
    </div>
  );
}
